import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Performance Reviews list (CLAUDE.md §2.3),
 * mirroring the Employees list store. Search/status filters live in URL-bound page
 * state and stay out of the store — those are server-driven query params, not
 * durable user prefs.
 */
export type ReviewsViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const REVIEWS_VIEW_MODES: ReviewsViewMode[] = [
  'table',
  'list',
  'cards',
  'grouped',
];

interface ReviewsUiState {
  view: ReviewsViewMode;
  setView: (view: ReviewsViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-review_date`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useReviewsUi = create<ReviewsUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'hrm.reviews:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
